import MRomComsCarousel from '../carousels/MRomComsCarousel';
import React, { ReactNode, useCallback, useState } from 'react';
import image1 from '../../../../assets/images/games/m-game/films/CountryVSrdci.webp';
import image10 from '../../../../assets/images/games/m-game/films/LoveActually.webp';
import image11 from '../../../../assets/images/games/m-game/films/AboutTime.webp';
import image12 from '../../../../assets/images/games/m-game/films/MyBigFatGreekWedding.webp';
import image13 from '../../../../assets/images/games/m-game/films/TheresSomethingAboutMary.webp';
import image14 from '../../../../assets/images/games/m-game/films/OnJeFaktBozi.webp';
import image15 from '../../../../assets/images/games/m-game/films/PoCemZenyTouzi.webp';
import image16 from '../../../../assets/images/games/m-game/films/PrettyWoman.webp';
import image17 from '../../../../assets/images/games/m-game/films/13GoingOn30.webp';
import image18 from '../../../../assets/images/games/m-game/films/PychaAPredsudok.webp';
import image19 from '../../../../assets/images/games/m-game/films/MissCongeniality.webp';
import image2 from '../../../../assets/images/games/m-game/films/4WeddingsAndAFuneral.webp';
import image20 from '../../../../assets/images/games/m-game/films/SvatbyPodleMary.webp';
import image21 from '../../../../assets/images/games/m-game/films/WhatIf.webp';
import image3 from '../../../../assets/images/games/m-game/films/BridgetJonesDiary.webp';
import image4 from '../../../../assets/images/games/m-game/films/10ThingsIHateAboutYou.webp';
import image5 from '../../../../assets/images/games/m-game/films/BridgetJonesBaby.webp';
import image6 from '../../../../assets/images/games/m-game/films/Emma.webp';
import image7 from '../../../../assets/images/games/m-game/films/MadeOfHonor.webp';
import image8 from '../../../../assets/images/games/m-game/films/HowToLoseAGuyIn10Days.webp';
import image9 from '../../../../assets/images/games/m-game/films/MaidInManhattan.webp';
import imageLast from '../../../../assets/images/games/m-game/films/last.webp';

export default function MRomComsCipher() {
    const [selectedSlide, setSelectedSlide] = useState(0);
    const [images, setImages] = useState([
        { url: image2, id: 2 },
        { url: image11, id: 11 },
        { url: image6, id: 6 },
        { url: image9, id: 9 },
        { url: image4, id: 4 },
        { url: image1, id: 1 },
        { url: image13, id: 13 },
        { url: image21, id: 21 },
        { url: image15, id: 15 },
        { url: image10, id: 10 },
        { url: image3, id: 3 },
        { url: image20, id: 20 },
        { url: image16, id: 16 },
        { url: image19, id: 19 },
        { url: image8, id: 8 },
        { url: image17, id: 17 },
        { url: image14, id: 14 },
        { url: image5, id: 5 },
        { url: image7, id: 7 },
        { url: image18, id: 18 },
        { url: image12, id: 12 },
        { url: imageLast, id: 100 },
    ]);
    const [films, setFilms] = useState([
        { name: 'Country v srdci', id: 1 },
        { name: 'Čtyři svatby a jeden pohřeb', id: 2 },
        { name: 'Deník Bridget Jonesové', id: 3 },
        { name: 'Deset důvodů, proč tě nenávidím', id: 4 },
        { name: 'Dítě Bridget Jonesové', id: 5 },
        { name: 'Emma', id: 6 },
        { name: 'Jak ukrást nevěstu', id: 7 },
        { name: 'Jak ztratit kluka v 10 dnech', id: 8 },
        { name: 'Krásná pokojská', id: 9 },
        { name: 'Láska nebeská', id: 10 },
        { name: 'Lásky čas', id: 11 },
        { name: 'Moje tlustá řecká svatba', id: 12 },
        { name: 'Něco na té Mary je', id: 13 },
        { name: 'On je fakt boží!', id: 14 },
        { name: 'Po čem ženy touží', id: 15 },
        { name: 'Pretty Woman', id: 16 },
        { name: 'Přes noc třicítkou', id: 17 },
        { name: 'Pýcha a předsudek', id: 18 },
        { name: 'Slečna Drsňák', id: 19 },
        { name: 'Svatby podle Mary', id: 20 },
        { name: 'What If', id: 21 },
    ]);

    const onCompleteSlide = useCallback((idx: number, _item: ReactNode) => {
        setSelectedSlide(idx);
    }, []);

    const removeOnIndex = (n: number) => {
        if (n === images[selectedSlide].id) {
            const filteredImages = images.filter((v) => v.id !== n);
            const filteredFilms = films.filter((v) => v.id !== n);
            setImages(filteredImages);
            setFilms(filteredFilms);
        }
    };
    return (
        <React.Fragment>
            <div className="m-romcoms">
                <MRomComsCarousel onCompleteSlide={onCompleteSlide} images={images} />
                {films && films.length > 0 && (
                    <div className="m-romcoms-names-wrapper">
                        {films?.map((f, i) => {
                            return (
                                <div className="m-romcoms-name" key={i} onClick={() => removeOnIndex(f.id)}>
                                    {f.name}
                                </div>
                            );
                        })}
                    </div>
                )}
                {!images || (images.length === 1 && <div className="m-romcoms-solved">Problém vyriešený</div>)}
            </div>
        </React.Fragment>
    );
}
